// The breakthrough toast (art audit P6): your research project completed.
// Its own lane — below the merchant offer, above nothing — so it can never
// land on the attack toasts.
import { useT } from '../i18n/index.js';
import { appDom } from '../lib/appDom.js';
import type { ResearchToast } from '../sim/useResearchToasts.js';
import { sceneUrls } from './scenes.js';

export function ResearchToastStack({
  toasts,
  onDismiss,
}: {
  readonly toasts: ReadonlyArray<ResearchToast>;
  readonly onDismiss: (id: number) => void;
}) {
  const t = useT();
  if (toasts.length === 0) return null;
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-[calc(var(--hud-panel-top)+10.5rem)] z-50 flex flex-col items-center gap-2 px-3"
      aria-live="polite"
      data-testid="research-toasts"
    >
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          data-testid="research-toast"
          {...appDom({ id: 'research-toast', type: 'Toast', scope: 'toast' })}
          aria-label={t('research.breakthrough')}
          onClick={() => onDismiss(toast.id)}
          className="animate-slide-up pointer-events-auto flex w-full max-w-[min(92vw,420px)] items-center gap-3 rounded-xl border border-sky-500/50 bg-panel-scrim px-4 py-2.5 text-left text-foreground shadow-[0_0_24px_rgba(120,190,255,0.16)] backdrop-blur-sm dark:shadow-[0_0_30px_rgba(120,190,255,0.22)]"
        >
          <img
            src={sceneUrls(toast.scene.group, toast.scene.id).srcSmall}
            alt=""
            loading="lazy"
            className="h-10 w-[4.5rem] shrink-0 rounded border border-sky-500/30 object-cover"
            data-testid="research-toast-scene"
          />
          <span className="flex min-w-[10rem] flex-1 flex-col">
            <span className="font-serif leading-tight text-sm text-sky-700 dark:text-sky-300">
              {t('research.breakthrough')}
            </span>
            <span className="truncate text-xs text-muted-foreground">
              {t('research.breakthrough.sub')}
            </span>
          </span>
        </button>
      ))}
    </div>
  );
}
